"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function cov_2q1zvt2j2w() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Placeholder.tsx";
  var hash = "424db401f5ab8b09ee5d3189b0bca9c7152c4970";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Placeholder.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 51
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "424db401f5ab8b09ee5d3189b0bca9c7152c4970"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2q1zvt2j2w = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2q1zvt2j2w();
var Icon = (cov_2q1zvt2j2w().s[0]++, {
  name: 'placeholder',
  svg: "<circle cx=\"12\" cy=\"12\" r=\"9\" fill=\"currentColor\"/>"
});
var _default = exports["default"] = Icon;